// extracted by mini-css-extract-plugin
module.exports = {"gallery":"GalleryPage_gallery__3kR98"};